import React from 'react'

import { PlanFragment, StripeSubscription } from 'src/graphql'

import { planDetails } from '../../constants'
import PlanTile from './PlanTile'
import { style } from './pricingTableStyles'

type PlanTileGroupProps = {
  shouldAddSpacer?: boolean
  plans: PlanFragment[]
  onSelect: (plan: string, isKeepButton?: boolean) => void
  stripeSubscription?: Partial<StripeSubscription>
  getPlan: (planId: string) => PlanFragment | undefined
}

const PlanTileGroup: React.FC<PlanTileGroupProps> = props => {
  const {
    plans,
    onSelect,
    shouldAddSpacer = false,
    stripeSubscription,
    getPlan,
  } = props

  return (
    <div style={{ display: 'flex' }}>
      {shouldAddSpacer && <div style={style.planSpacer} />}
      {plans.map(plan => (
        <PlanTile
          key={plan.title}
          plan={plan}
          details={planDetails.find(p => p.plan === plan.title)}
          onSelect={onSelect}
          containerStyle={{ minWidth: 0 }}
          stripeSubscription={stripeSubscription}
          getPlan={getPlan}
        />
      ))}
    </div>
  )
}

export default PlanTileGroup
